import { create } from "zustand"
import { devtools } from "zustand/middleware"

// Custom Table 컬럼(숫자 범위) 필터의 임시(transient) 상태 — reportSort 와 같은 스코프 규칙.
// 화면(CustomTableSection)이 쓰고 PDF(PrintableCustomTableSection)가 읽어 "화면에 남은 행 = PDF 행 = 요약 행 기준"을
// 맞춘다 (일감 #98 WYSIWYG). 템플릿이 실제로 바뀌면 폐기, 같은 템플릿 재진입(뒤로가기)에는 보존.
export type ColumnFilter = {
  min: number
  max: number
  range: [number, number]
}

export type ColumnFilterMap = Record<string, ColumnFilter>

interface ReportColumnFilterState {
  filters: Record<string, ColumnFilterMap | undefined>
  lastTemplateId: Record<string, string | number | undefined>
  setFilters: (sectionKey: string, filters: ColumnFilterMap | undefined) => void
  syncTemplate: (reportType: string, templateId: string | number | undefined) => void
}

export const createReportColumnFilterStore = create<ReportColumnFilterState>()(
  devtools(
    (set) => ({
      filters: {},
      lastTemplateId: {},
      setFilters: (sectionKey, filters) =>
        set((state) => ({ filters: { ...state.filters, [sectionKey]: filters } })),
      syncTemplate: (reportType, templateId) =>
        set((state) => {
          if (state.lastTemplateId[reportType] === templateId) {
            return state
          }

          return {
            filters: Object.fromEntries(
              Object.entries(state.filters).filter(([key]) => !key.startsWith(`${reportType}:`)),
            ),
            lastTemplateId: { ...state.lastTemplateId, [reportType]: templateId },
          }
        }),
    }),
    {
      store: "reportColumnFilter",
      enabled: process.env.NODE_ENV !== "production",
    },
  ),
)

/** 필터가 기본 범위(min~max 전체)에서 벗어난 것만 "활성" 필터로 본다 */
export function isColumnFilterActive(filter: ColumnFilter | undefined): boolean {
  return !!filter && (filter.range[0] !== filter.min || filter.range[1] !== filter.max)
}

export function hasActiveColumnFilters(filters: ColumnFilterMap | undefined): boolean {
  return !!filters && Object.values(filters).some(isColumnFilterActive)
}
